
export default {
  name: 'VsNode',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    html: {
      type: String,
      default: null
    }
  },
  vessel: {
    node: {
      $attrs: 'all'
    }
  },
  render(h) {
    const slot = this.$slots.default || []
    const opts = { on: this.$listeners, class: this.$vessels.node }

    if (!slot.length && this.html) {
      opts.domProps = { innerHTML: this.html }
    }

    return h(this.tag, opts, slot)
  }
}
